import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// 🔥 Firebase ve Auth Hook
import { auth } from "./firebase";
import { useAuthState } from "react-firebase-hooks/auth";

// 🔥 FontContext (Yazı Tipleri)
import { FontProvider } from "./context/FontContext"; 

// 🔥 Bileşenler (Dosya yollarına dikkat et)
import Header from "./components/Header";
import Dashboard from "./components/Dashboard";
import TestPage from "./components/TestPage";
import Login from "./components/Login";
import Register from "./components/Register";
import CareerSim from "./components/CareerSim"; // Simülasyon Bileşeni

// 🔥 Sayfalar (Pages)
import ResultsPage from "./pages/ResultsPage";
import AiReport from "./pages/AiReport"; // AI Rapor Sayfası

// 🔒 KORUYUCU ROUTE (Giriş yapmamış kullanıcıyı engeller)
function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <h3>Yükleniyor...</h3>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default function App() {
  return (
    // Tüm uygulama FontProvider ile sarmalandı
    <FontProvider> 
      <Router>
        <Header />
        <div className="main-content" style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
          <Routes>
            {/* --- AÇIK YOLLAR --- */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* --- KORUMALI YOLLAR (Giriş Şart) --- */}
            
            {/* Ana Sayfa (Dashboard) */}
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            {/* Test Çözme Ekranı */}
            <Route path="/test/:testKey" element={<ProtectedRoute><TestPage /></ProtectedRoute>} />
            
            {/* Test Sonuçları */}
            <Route path="/results/:testKey" element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />

            {/* 🤖 YENİ: AI Raporu (Yol Haritası & Üniversiteler) */}
            <Route path="/ai-report" element={<ProtectedRoute><AiReport /></ProtectedRoute>} />

            {/* 🎮 YENİ: Kariyer Simülasyonu (Oyun) */}
            <Route path="/career-sim" element={<ProtectedRoute><CareerSim /></ProtectedRoute>} />
            
            {/* Hatalı link girilirse ana sayfaya at */}
            <Route path="*" element={<Navigate to="/" replace />} />

          </Routes>
        </div>
      </Router>
    </FontProvider>
  );
}